import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Datipreventivo, typedati } from '../model/datipreventivo';
import { Observer } from 'rxjs/Observer';
import { DatipreventivoService } from '../service/datipreventivo.service';
import { Offerte } from '../model/offerte';
import { OfferteServiceService } from '../service/offerte-service.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { Lead } from '../model/lead';
import { LeadserviceService } from '../service/leadservice.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-preventivo',
  templateUrl: './preventivo.component.html',
  styleUrls: ['./preventivo.component.scss']
})
export class PreventivoComponent implements OnInit {




  origine: number;
  idcomodity;
  dati: Datipreventivo;
  lstOfferte: Array<Offerte>;

  private sub: any;
  public state: number;
  touchedform: boolean;
  constructor(private datepipe: DatePipe, private route: ActivatedRoute, private router: Router, private service: DatipreventivoService, private serviceofferte: OfferteServiceService, private servicelead: LeadserviceService) {
    this.dati = null;
    this.lstOfferte = null;
    this.state = 1;
    this.touchedform = false;

  }

  async delayasync(ms: number) {
    await this.delay(ms);
  }
  @Input() idcomodityinput: number;

  ngOnInit() {



    this.idcomodity = 0;
    this.sub = this.route.params.subscribe(params => {
      this.idcomodity = +params['idcomodity']; // (+) converts string 'id' to a number

      this.dati = this.service.getDati(this.idcomodity);
      this.state = 1;
    });
    this.route.data.subscribe(o => this.origine = o.origine);

    if (this.idcomodityinput != null && this.idcomodityinput > 0) {
      this.idcomodity = this.idcomodityinput;
      this.dati = this.service.getDati(this.idcomodity);
    }

    if (this.idcomodity == null || this.idcomodity == 0) {
      this.idcomodity = 1;
      this.dati = this.service.getDati(this.idcomodity);
    }
  }


  public changeComodity(id_Comodity: number) {
    this.idcomodity = id_Comodity;

    this.dati = null;
    this.dati = this.service.getDati(id_Comodity);
    this.lstOfferte = null;
    this.state = 1;
  }

  public async clickChiama(nomeofferta: string) {
    if (this.origine == 1) {
      this.servicelead.setIddem(68);
      this.dati.lead.dataappuntamento = null;
      this.dati.lead.Note = nomeofferta;
      this.state = 3;
      this.servicelead.sendleads(this.dati.lead, "").subscribe(
        o => {

          this.state = 5;
          console.log(this.state);
          console.log(o);

        }, error => { this.state = 5; console.log("errore api") }
      )
    }


  }
  public async compara() {
  // || (this.state == 1 && this.origine == 2) operatore vede la raccolta dati
    if (this.state == 2 || this.state == 4 || this.state == 5 ) {
      if (this.validdati()) {
        this.lstOfferte = null;
        this.state = 3;
        this.lstOfferte=null;

        this.serviceofferte.getOfferteComparatore(this.dati).subscribe( data => this.lstOfferte=data);

        await this.delay(2000);
        while ( this.lstOfferte==null )
        {
          await this.delay(1000);
        }

        this.servicelead.setIddem(68);
        this.dati.lead.dataappuntamento = this.datepipe.transform(new Date().setMinutes(new Date().getMinutes() + 30), "yyyy-MM-dd HH:mm:ss");
        this.dati.lead.Note = null;
        console.log(this.dati.lead.dataappuntamento);
        this.state = 3;
        if (this.origine == 1) {
          this.servicelead.sendleads(this.dati.lead, "").subscribe(
            o => {


              console.log(this.state);
              console.log(o);

            }, error => { console.log("errore api") }
          )
        }
        this.state = 4;
      }
      else {
        this.touchedform = true;
      }
    }
    if (this.state == 1) {
      if (this.validadatiextra()) {

        this.state = 2;
      }

      else {
        this.touchedform = true;
      }
    }

  }

  private validadatiextra(): boolean {

    return this.dati.datiextra.filter(o => o.valore != ""  && +o.valore>0).length == this.dati.datiextra.length;
  }

  validateEmail(email): boolean {
    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
     var re = /^$|^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    return re.test(String(email).toLowerCase());
  }
  private validdati(): boolean {
    // return true;


    return ((this.dati.lead.cognome != "" &&
      this.dati.lead.nome != "" &&
      this.dati.lead.cap != "" &&
      this.dati.lead.telefono != "" &&
      // this.dati.lead.email != "" &&
      this.validateEmail(this.dati.lead.email) &&
      this.dati.lead.privacy1 &&
      this.dati.lead.privacy2) || this.origine == 2) &&
      this.dati.datiextra.filter(o => o.valore != ""&& +o.valore>0 ).length == this.dati.datiextra.length;
  }
  public changevalueradio(dato: typedati, valore: string) {
    dato.valore = valore;
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  public stylecolum6(): boolean {
    return this.state < 4;
  }
  public stylecolum9(): boolean {
    return this.state > 3;
  }
}




// WEBPACK FOOTER //
// ./src/app/preventivo/preventivo.component.ts